module.exports =
  '_GROUP_INFORMATION':
    'TITLE': "Group"
    'EDIT_GROUP': 'Edit group information'
    'NUM_MEMBERS': 'Member List({0})'
    'EDIT_MEMBER': 'Edit member'
    'EVENT': 'Event'
    'LEAVE_GROUP': 'Leave group'
    'RECENT_EVENTS': 'Recent events'
    'GROUP_ADMIN': 'Group Administrator'
    'GROUP_ADMIN_SMALL': 'Admin'
    'ALL_MEMBERS': 'Check all members'
    'ALL_EVENTS': 'Check event list'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-info/i18n/en.coffee